import { render, staticRenderFns } from "./meiwen.vue?vue&type=template&id=674c4556&scoped=true&"
import script from "./meiwen.vue?vue&type=script&lang=js&"
export * from "./meiwen.vue?vue&type=script&lang=js&"
import style0 from "./meiwen.vue?vue&type=style&index=0&id=674c4556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674c4556",
  null
  
)

export default component.exports